import React from 'react';
import {
    View,
    StyleSheet,
} from "@react-pdf/renderer";
import {PdfElementProps} from "./_models";

export function PdfSpaceComponent({config}: PdfElementProps) {
    const style = StyleSheet.create({
        main: {
            ...{
                width: '100%',
                height: '10px'
            },
            ...(config.style || {}),
        }
    })

    return (
        <View style={style.main}/>
    )
}